module.exports = __webpack_public_path__ + "img/no-img.2571125.webp";